import React from 'react';

export default function Ticker({ text, settings = {} }) {
  if (!text) return null;
  const bg        = settings['ticker.bg']    || 'var(--color-accent)';
  const textColor = settings['ticker.color'] || 'var(--color-primary)';
  const doubled   = [text, text];
  return (
    <div style={{ position:'fixed', top:64, left:0, right:0, zIndex:998, background: bg, height:32, display:'flex', alignItems:'center', overflow:'hidden' }}>
      <style>{`
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        .ticker-track { display:flex; animation:ticker 30s linear infinite; white-space:nowrap; }
        .ticker-item { font-size:10px; font-weight:600; color:${textColor}; letter-spacing:1.5px; text-transform:uppercase; padding:0 2.5rem; }
        @media(min-width:768px){ .ticker-item { font-size:11px; padding:0 3rem; } }
      `}</style>
      <div className="ticker-track">
        {doubled.map((t,i) => <span key={i} className="ticker-item">{t}</span>)}
      </div>
    </div>
  );
}
